<template>
    <div>
        <search-tabs :type="'tyre_category'" :name="tyre_category.name" :image_path="this.pageDetails.image_base_path+this.pageDetails.image_path"></search-tabs>

        <!-- <div class="breadcrum pb-2 pt-2">
            <div class="container">
                <router-link class="color-black" :to="{ name: 'home' }"> <i class="fas fa-home"></i> </router-link> / 
                {{ $t("Result") }}
            </div>
        </div> -->
        <!-- <div class="container pt-3">
                <div class="row">
                    <h1>{{tyreCategorySlug}} Tyres</h1>
                </div>
        </div> -->
        <div class="container pt-3">
            <div class="row" v-if="pageDetails.block1_description">
                <!-- <h3>Brand Description</h3> -->
                <p style="width: 100%" class="ql-editor" v-html="pageDetails.block1_description"></p>
                <vue-editor style="display:none" />
            </div>
            <div class="row">
                <div class="col-md-4 col-lg-4 col-xl-3" v-if="pageDetails.block2_description">
                    <h3 class="text-center">About {{ tyreCategorySlug }}</h3>
                    <hr>
                    <p style="width: 100%" class="ql-editor" v-html="pageDetails.block2_description"></p>
                    <vue-editor style="display:none" />
                </div>
                <div :class="(pageDetails.block2_description) ? 'col-md-8 col-lg-8 col-xl-9' : 'col-md-12 col-lg-12 col-xl-12'">
                    <h3 class="text-center pb-2" v-if="tyreTypeTyreList.length">{{ $t('Most Popular Tyres') }}</h3>
                    <div class="row">
                        <div v-for="product in tyreTypeTyreList" :key="product.id" :class="(pageDetails.block2_description) ? 'col-md-12 col-lg-4' : 'col-md-12 col-lg-3'">
                            <single-product :product="product"></single-product>
                        </div>
                        <div class="col-md-12 col-lg-12" v-if="totalTyres != 0 && totalTyres > tyresPageSize">
                            <b-pagination 
                                pills 
                                v-model="currentTyrePage" 
                                :total-rows="totalTyres"
                                size="sm"
                                align="center"
                                class="mb-3 mt-2"
                                :per-page="tyresPageSize"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <hr v-if="pageDetails.block3_description">
            <div class="row" v-if="pageDetails.block3_description">
                <p style="width: 100%" class="ql-editor" v-html="pageDetails.block3_description"></p>
                <vue-editor style="display:none" />
            </div>
        </div>
    </div>
</template>

<style scoped>
    .page .product-item { flex-direction:column;}
    .page .product-item .product-image, .product-item .product-info, .page .product-image { flex-basis: 100%; }
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import { VueEditor } from "vue2-editor"
import SearchTab from "../components/SearchTabs.vue";
import SingleProduct from "../components/SingleProduct.vue";
export default {
    name: "tyre_category",
    metaInfo() {
        return{
            title: this.tyreCategorySlug,
            meta: [
                { charset: 'utf-8' },
                { name: 'title', content: this.tyreCategorySlug},
                { name: 'description', content: this.pageDetails.meta_description},
                { name: 'keywords', content: 'renkaatalle, Renkaatalle.fi'},
                { name: 'robots', content: 'index,follow'}
            ]
        }
    },
    components: { VueEditor, "search-tabs": SearchTab, "single-product" : SingleProduct },
    data() {
      return {
        tyre_category: {name: ''},
        pageType: 'tyre_category',
        tyreCategorySlug: null,
        currentTyrePage: 1,
        modelPageSize: 36,
        totalModels: 0,
        modelTotalPage: 0,
        tyresPageSize: 12,
        totalTyres: 0,
        tyresTotalPage: 0,
        bannerLoading: true
      }
    },
    async created() {
        document.body.classList.add('home');
        this.tyreCategorySlug = this.$route.params.tyrecategory
        await this.getTyrecategoryDetail(this.tyreCategorySlug)
        await this.getPageDetails()
        await this.getTyres()
    },
    watch: {
        '$route.query': {
            async handler() {
                this.currentPage = 1;
            }
        },
        currentTyrePage (value) {
            this.getTyres()
            this.tyresTotalPage < value
        },
        "currentLang": {
            async handler() {
                await this.getPageDetails()
                await this.getTyres()
            }
        },
        "pageDetails": {
            handler() {}
        }
    },
    computed: {
        ...mapGetters('app', ['currentLang']),
        ...mapGetters('page', ['tyreTypeTyreList', 'pageDetails']),
    },
    methods: {
        ...mapActions("page", ['fetchTyrecategoryDetail', 'fetchTyreTypeTyres', 'fetchPageDetails']),
        getPageDetails() {
            this.bannerLoading = true
            this.fetchPageDetails({type: this.pageType, type_name: this.tyreCategorySlug}).then(response => {
                this.bannerLoading = false
            })
            .catch(error => {
            }).finally(() => {
                this.loading = false;
            });
        },
        getTyrecategoryDetail(slug) {
            this.bannerLoading = true
            this.fetchTyrecategoryDetail(slug).then(response => {
                if (response.data) {
                    this.tyre_category = response.data
                }
                this.bannerLoading = false
            })
            .catch(error => {
            }).finally(() => {
                this.loading = false;
            });
        },
        getTyres() {
            let strDyn = "?per_page="+this.tyresPageSize+"&page="+this.currentTyrePage;

            this.fetchTyreTypeTyres({tyre_category: this.tyreCategorySlug, queryString: strDyn}).then(response => {
                this.totalTyres = response.data.total;
                this.tyresTotalPage= response.data.last_page;
            })
            .catch(error => {
            }).finally(() => {
                this.loading = false;
            });        
        },
        getImageURL(product) {
            return "backgroundImage: url('" + product.image.image_base_path+product.image.path + "')";
        },
        setCurrency(total) {
            let price = null
            if(total) {
                return total.replace(".", ",")+process.env.VUE_APP_CURRENCY_SIGN;
            } else {
                return price
            }
        }
    }
};

</script>
